import { Rsp } from "@repo/types";
import { getHttpClient } from "./http";
import { ReportType } from "./report.type";
import type { StallInfo, SubmitReportData } from "./report.type";

const ReportTypeMap: Record<ReportType, number> = {
  [ReportType.USER]: 1,
  [ReportType.STALL]: 2,
};

export const ReportAPI = {
  getStallInfo(stallId: string) {
    return getHttpClient().get<Rsp<StallInfo>>({ url: `/stall/${stallId}` });
  },

  submitReport(data: SubmitReportData) {
    return getHttpClient().post<Rsp<{ id: string }>>({
      url: "/user/report/submit",
      data: {
        target_id: data.target_id,
        type: ReportTypeMap[data.type],
        content: data.content,
        attachments: data.evidence,
      },
    });
  },

  getReportDetail(reportId: string) {
    return getHttpClient().get<
      Rsp<{
        id: string;
        target_id: string;
        type: ReportType;
        content: string;
        attachments: string[];
        status: number;
        results?: string;
        create_at: string;
      }>
    >({ url: `/user/report/detail/${reportId}` });
  },

  cancelReport(reportId: string) {
    return getHttpClient().post<Rsp<null>>({
      url: `/user/report/cancel/${reportId}`,
      data: {},
    });
  },
};
